import constants from '../constants';

const { EDITOR3, STUDIO, CLASSIC, EDITOR, LIVESITE } = constants.EDITORTYPE;
type BiEditortype = typeof CLASSIC | typeof STUDIO | typeof EDITOR3;

function editortypeFromHost(
  host: string | undefined,
): BiEditortype | undefined {
  if (!host) {
    return undefined;
  }
  if (host === EDITOR3) {
    return EDITOR3;
  }
  if (host === STUDIO) {
    return STUDIO;
  }
  if (host === LIVESITE) {
    return undefined;
  }
  if (host === EDITOR || host === CLASSIC) {
    return CLASSIC;
  }
  return undefined;
}

function editortypeFromFlags(
  isEditor3: boolean,
  isResponsive: boolean,
): BiEditortype {
  return isEditor3 ? EDITOR3 : isResponsive ? STUDIO : CLASSIC;
}

/**
 * Resolves BI editortype for events (faqAppLoads, faqAppStartLoading).
 * Returns exactly one of: 'editor3', 'studio', or 'classic'. No other values.
 * Prefers host from commonConfig when it identifies an editor; otherwise uses isEditor3 and isResponsive flags (also when not in editor, e.g. live site).
 */
export function getEditortype(
  isEditor3: boolean,
  isResponsive: boolean,
  commonConfig?: { host?: string } | null,
): BiEditortype {
  const host = commonConfig?.host?.toLowerCase();
  const fromHost = editortypeFromHost(host);
  if (fromHost !== undefined) {
    return fromHost;
  }
  return editortypeFromFlags(isEditor3, isResponsive);
}
